import React, {useCallback, useEffect, useState} from "react"
import { ReactComponent as CalculatorIcon } from "../../assets/images/run-payroll-preview/calculator.svg"
import "./styles.scss"
import DarkTooltip from "../common/DarkToolTip"
import { styled } from "@mui/material/styles"
import { Badge } from "@mui/material"
import axios from "../../axios";
import toastService from "../../services/toastService";
import Loading from "../common/Loading";
import PayrollRecalculateMissingEmployeeModal from "../modals/PayrollRecalculateMissingEmployeeModal";

const StyledBadge = styled(Badge)(() => ({
  "& .MuiBadge-badge": {
    top: -12,
    right: -12,
    backgroundColor: "#F1AE15"
  }
}))

const CustomRecalculateToast = ({ handleOpenRecalculateModal, recalculateCount = 0, payrollId, type = "payroll" }) => {
  const [loading, setLoading] = useState(false)
  const [isOpenPayrollRecalculateMissingEmployeeModal, setIsOpenPayrollRecalculateMissingEmployeeModal] = useState(false)
  const [missingEmployees, setMissingEmployees] = useState([])

  const handleCloseRecalculateModal = () => setIsOpenPayrollRecalculateMissingEmployeeModal(false)

  const restoreToasterZIndex = useCallback(() => {
    const toasterContainer = document.querySelector("div[style*='z-index: 99']")
    if (toasterContainer) toasterContainer.style.zIndex = "9999"
  }, [])

  const isDesktop = window.matchMedia("(min-width: 999px)").matches

  useEffect(() => {
    if (type !== "statement" || !isDesktop) return

    const toasterContainer = document.querySelector("div[style*='z-index: 9999']")
    if (!toasterContainer) return

    toasterContainer.style.zIndex = "99"

    return () => restoreToasterZIndex()
  }, [type, isDesktop, restoreToasterZIndex])

  const handleClick = useCallback(async () => {
    if (loading) return

    setLoading(true)

    if (type === "statement" && isDesktop) restoreToasterZIndex()

    try {
        await axios
          .post(`/payroll/prepare-recalculate`)
          .then((response) => {
            if (response?.data?.length > 0) {
                setIsOpenPayrollRecalculateMissingEmployeeModal(true)
                setMissingEmployees(response?.data)
                return
            }

            handleOpenRecalculateModal()
          })
          .catch((err) => toastService.error(err.response?.data?.message || err.message))
          .finally(() => setLoading(false))
    } catch (e) {
        toastService?.error?.("Failed to prepare payroll recalculation")
    } finally {
        setLoading(false)
    }
  }, [loading, payrollId, handleOpenRecalculateModal, type, restoreToasterZIndex])

  return (
      <>
          {isOpenPayrollRecalculateMissingEmployeeModal === false && (
              <div className={`fw-toast ${type}`} role="status" aria-live="polite">
                  <div className="fw-toast__icon" aria-hidden>
                      <CalculatorIcon/>
                  </div>

                  <div className="fw-toast__content">
                      <div className="fw-toast__title">
                          Done editing? <strong>Recalculate now.</strong>
                      </div>
                      <div className="fw-toast__hint">Apply changes to totals & reports.</div>
                  </div>

                  {loading ? (
                      <Loading/>
                  ) : (
                      <button type="button" className="fw-btn fw-btn--primary" onClick={handleClick}>
                          Recalculate
                          <DarkTooltip
                              placement="top"
                              title="Update payroll with the latest rates & changes. This will overwrite current calculations"
                              arrow>
                              <StyledBadge color="warning" badgeContent={recalculateCount}/>
                          </DarkTooltip>
                      </button>
                  )}
              </div>
          )}

          <PayrollRecalculateMissingEmployeeModal
              open={isOpenPayrollRecalculateMissingEmployeeModal}
              handleClose={handleCloseRecalculateModal}
              missedEmployees={missingEmployees}
          />
      </>
  )
}

export default CustomRecalculateToast
